import * as React from "react";
import { Redirect, BrowserRouter, Route } from "react-router-dom";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {spring, AnimatedSwitch, Transition} from "react-router-transition";
import { Layout } from "antd";
const {Content, Footer } = Layout;

import {Header} from "./components/header";
import {RootState} from "./reducers";
import {LoginContainer} from "./containers/login";
import {HomeContainer} from "./containers/home";
import {logoutUser, loginFromCookie} from "./reducers/user/actions";

// we need to map the `scale` prop we define below
// to the transform style property
function mapStyles(styles: Transition): Transition {
  return {
    opacity: styles.opacity,
    transform: `scale(${styles.scale})`,
  };
}

// wrap the `spring` helper to use a bouncy config
function bounce(val: number): number {
  return spring(val, {
    stiffness: 330,
    damping: 22,
  });
}

// child matches will...
const bounceTransition = {
  // start in a transparent, upscaled state
  atEnter: {
    opacity: 0,
    scale: 1.2,
  },
  // leave in a transparent, downscaled state
  atLeave: {
    opacity: bounce(0),
    scale: bounce(0.8),
  },
  // and rest at an opaque, normally-scaled state
  atActive: {
    opacity: bounce(1),
    scale: bounce(1),
  },
};


const PrivateRoute: any = ({isLoggedIn, component: Component, ...rest}) => (
  <Route {...rest} render={props => (
    isLoggedIn ? (
      <Component {...props}/>
    ) : (
      <Redirect to={{
        pathname: "/login",
      }}/>
    )
  )}/>
);

interface Props {
  isLoggedIn: boolean;
  dispatch: Dispatch<{}>;
}

class AppRoutesComponent extends React.Component<Props, {}> {
  componentWillMount() {
    this.props.dispatch(loginFromCookie());
  }

  render(): JSX.Element {
    return (
      <Layout className="layout" style={{minHeight: "100vh"}}>
        <Header isLoggedIn={this.props.isLoggedIn} logout={() => this.props.dispatch(logoutUser())} />
        <Content>
          <BrowserRouter>
          <AnimatedSwitch
            atEnter={bounceTransition.atEnter}
            atLeave={bounceTransition.atLeave}
            atActive={bounceTransition.atActive}
            mapStyles={mapStyles}
            className="route-wrapper"
          >
              <PrivateRoute exact path="/" component={HomeContainer} isLoggedIn={this.props.isLoggedIn} />
              <Route path="/login" component={LoginContainer} />
              <Route path="*" render={() => (<Redirect to="/" />)} />
            </AnimatedSwitch>
          </BrowserRouter>
        </Content>
        <Footer />
      </Layout>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: state.user.isLoggedIn,
});

export const AppRoutes = connect(mapStateToProps)(AppRoutesComponent);



// WEBPACK FOOTER //
// ./src/routes.tsx